import { render } from "./SFormElementLegalCheckbox.vue?vue&type=template&id=2b1bb2a2&scoped=true&ts=true"
import script from "./SFormElementLegalCheckbox.vue?vue&type=script&lang=ts"
export * from "./SFormElementLegalCheckbox.vue?vue&type=script&lang=ts"

import "./SFormElementLegalCheckbox.vue?vue&type=style&index=0&id=2b1bb2a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1bb2a2"]])

export default __exports__